<template>
	<div>
		<div class="container">
			<div class="handle-box">
				<el-select size="small" v-if="isAdmin" @change="agentChange" v-model="query.agentId" filterable
					clearable placeholder="代理商" class="handle-select mr10" style="width: 260px;">
					<el-option v-for="item in agents" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
				<el-select size="small" style="width: 260px" v-if="isAdmin || isAgent" v-model="query.companyId"
					filterable clearable placeholder="企业" class="handle-select mr10">
					<el-option v-for="item in companys" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
				<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search" @click="getQuotaList">查询</el-button>
				<el-button size="small" type="primary" :class="[theme]" class="handle-add" @click="showAddDialog">设置配额</el-button>
			</div>
			<el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
				max-height="600" :row-style="{ height: '20px' }" :header-cell-style="{ 'text-align': 'center' }"
				v-loading="loading" :cell-style="{ padding: '6px' }" stripe>
				<el-table-column prop="companyName" label="企业" align="center"></el-table-column>
				<el-table-column prop="cardTypeName" label="品牌" align="center"></el-table-column>
				<el-table-column prop="quota" label="配额" align="center"></el-table-column>
				<el-table-column label="操作" width="190" align="center">
					<template #default="scope">
						<el-button size="small" type="text" @click="editHandle(scope.row)">编辑</el-button>
						<el-button size="small" type="text" icon="el-icon-delete" style="color: #f56c6c;"
							@click="handleDelete(scope.row.id)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-dialog title="设置配额" v-model="addVisible" width="500px" @close="closeDialog('form')"
			style="min-height: 30%;" :close-on-click-modal="false">
			<el-form :model="form" ref="form" label-width="100px">
				<el-form-item label="企业" v-if="isAdmin">
					<el-select v-model="form.companyId" placeholder="请选择企业" clearable filterable size="small" style="width: 100%;">
						<el-option v-for="item in companys" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="品牌">
					<el-select v-model="form.cardTypeId" placeholder="请选择品牌" clearable filterable size="small" style="width: 100%;">
						<el-option v-for="item in cardTypeList" :key="item.label" :label="item.value" :value="item.label"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="配额">
					<el-input v-model.number="form.quota" placeholder="请输入配额数量" size="small"></el-input>
				</el-form-item>
			</el-form>
			<div style="display: flex;flex-direction: row;justify-content: flex-end;margin-top: 20px;">
				<el-button size="small" @click="closeDialog('form')">取消</el-button>
				<el-button size="small" type="primary" :class="[theme]" @click="saveQuota('form')">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getQuotaList as getQuotaListApi,
		saveQuota as saveQuotaApi,
		deleteQuota as deleteQuotaApi
	} from '../../api/companyCardQuota.js';
	import {
		fetchDefaultCompanies,
		fetchCompanyByAgentId,
		list
	} from '../../api/companyIndex.js';
	import {
		getCardType
	} from '../../api/cardType.js';
	import {
		fetchAgent
	} from '../../api/agentIndex';

	export default {
		name: 'companyCardQuota',
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				tableData: [],
				agents: [],
				companys: [],
				cardTypeList: [],
				addVisible: false,
				isAdmin: false,
				isAgent: false,
				query: {
					agentId: null,
					companyId: ''
				},
				form: {
					id: '',
					companyId: '',
					cardTypeId: '',
					quota: null
				}
			};
		},
		created() {
			this.getRole();
			this.getCardTypeList();
			this.getAgentList();
			this.getCompanyList();
		},
		methods: {
			getRole() {
				let role = localStorage.getItem('ms_role');
				this.isAdmin = role === 'admin';
				this.isAgent = role === 'agent';
			},
			getAgentList() {
				fetchAgent(localStorage.getItem('user')).then(res => {
					if (res?.code === 200) {
						this.agents = res.data;
					}
				});
			},
			getCompanyList() {
				let data = {
					currentUserId: localStorage.getItem('user')
				};
				fetchDefaultCompanies(data).then(res => {
					if (res?.code === 200) {
						this.companys = res.data;
						if (this.isAgent && this.companys.length > 0 && !this.query.companyId) {
							this.query.companyId = this.companys[0].value;
							this.getQuotaList();
						}
					}
				});
			},
			getCardTypeList() {
				getCardType().then(res => {
					if (res?.code === 200) {
						this.cardTypeList = res.data;
					}
				});
			},
			agentChange() {
				this.query.companyId = '';
				if (this.query.agentId) {
					let data = {
						agentId: this.query.agentId,
						subAgent: JSON.parse((localStorage.getItem('subAgent') || 'false').toLowerCase())
					};
					fetchCompanyByAgentId(data).then(res => {
						if (res?.code === 200) {
							this.companys = res.data;
						}
					});
				} else {
					this.getCompanyList();
				}
			},
			getQuotaList() {
				if (!this.query.companyId && !this.isAdmin) {
					this.tableData = [];
					return;
				}
				this.loading = true;
				getQuotaListApi({ companyId: this.query.companyId }).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			showAddDialog() {
				if (!this.query.companyId && this.isAgent) {
					this.$message.warning('请先选择企业');
					return;
				}
				this.form = {
					id: '',
					companyId: this.isAgent ? this.query.companyId : '',
					cardTypeId: '',
					quota: null
				};
				this.addVisible = true;
			},
			editHandle(row) {
				const exists = this.companys.some(c => c.value === row.companyId);
				if (!exists && row.companyId) {
					this.companys.push({ value: row.companyId, label: row.companyName });
				}
				this.form = {
					id: row.id,
					companyId: row.companyId,
					cardTypeId: row.cardTypeId,
					quota: row.quota
				};
				this.addVisible = true;
			},
			saveQuota(formName) {
				if (!this.form.companyId) {
					this.$message.warning('请选择企业');
					return;
				}
				if (!this.form.cardTypeId) {
					this.$message.warning('请选择品牌');
					return;
				}
				if (this.form.quota === null || this.form.quota === '') {
					this.$message.warning('请输入配额');
					return;
				}
				this.loading = true;
				saveQuotaApi(this.form).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.$message.success('保存成功');
						this.addVisible = false;
						this.getQuotaList();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			handleDelete(id) {
				this.$confirm('确定要删除此配额吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true;
					deleteQuotaApi({ id: id }).then(res => {
						this.loading = false;
						if (res?.code === 200) {
							this.$message.success('删除成功');
							this.getQuotaList();
						} else {
							this.$message.error(res.message);
						}
					});
				}).catch(() => {});
			},
			closeDialog(formName) {
				this.addVisible = false;
				if (this.$refs[formName]) {
					this.$refs[formName].resetFields();
				}
			}
		}
	};
</script>

<style scoped lang="scss">
	.container {
		padding: 20px;
		background-color: #ffffff;
		border-radius: 4px;
		min-height: 100px;
	}

	.handle-box {
		display: flex;
		margin-bottom: 20px;
	}

	.table {
		margin-top: 10px;
	}

	.mr10 {
		margin-right: 10px;
	}
</style>
